import React, { Fragment } from "react";
import { Admin, Capture, Dispatch, VendorAgent } from "../../../../Data/SideMenu/RouteMapping";
import { getUserRole } from "../../../../Services/Shared.service";
import { DropdownItem } from "reactstrap";
const VendorQuickActions = (props) => {

  console.log(">>>>>> PROPS IN VENDOR QUICK ACTION VALUE IS ::: ", props);
  
  const userRole = getUserRole();
  console.log("userRole", userRole)

  return (
    <Fragment>
      <DropdownItem
        className="border-0"
        key={"row-edit"}
        disabled={
          userRole.some((element) => element === VendorAgent) && props.element.currentTripStatusType == "InProgress"
            ? false
            : true
        }
        onClick={() => {
          props.toggleEndTripModal();
        }}
      >
        <i className="fa fa-pencil"></i> End Trip
      </DropdownItem>
      {props.element.currentTripStatusType == "Confirmed" || props.element.currentTripStatusType ==  "ReachedPickup" ? (
        <DropdownItem
          className="border-0"
          key={"row-assigndriver"}
          onClick={() => {
            props.toggleStartTripModal();
          }}
        >
          <i className="fa fa-location-arrow"></i>Start Trip
        </DropdownItem>
      ) : (
        ""
      )}
    </Fragment>
  );
};

export default VendorQuickActions;
